import React from "react";
import styled from "styled-components";

const Footer = () => {
  return (
    <StyledFooter>
      <SocialsList>
        <SocialIcon
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          ⇪
        </SocialIcon>
      </SocialsList>
    </StyledFooter>
  );
};

export default Footer;

const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  background-color: ${({ theme }) => theme.body};
`;

const SocialsList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SocialIcon = styled.div`
  width: 36px;
  height: 36px;
  padding: 0.6rem;
  color: ${(theme) => theme.body};
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: 0.5s ease;

  &:hover {
    transform: scale(1.3);
    cursor: pointer;
  }
`;
